import { SITE } from '@/lib/site'

/** Barra fina preta: a frase à esquerda, o e-mail de suporte à direita. */
export function TopBar() {
  return (
    <div className="bg-ink text-white">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-1 px-4 py-2 text-xs sm:flex-row sm:items-center sm:justify-between">
        <span className="font-medium">{SITE.topBar}</span>
        <a
          href={`mailto:${SITE.supportEmail}`}
          className="text-white/75 underline-offset-2 hover:text-white hover:underline"
        >
          {SITE.supportEmail}
        </a>
      </div>
    </div>
  )
}
